import React from "react";

import _ from "lodash";

import PropTypes from "prop-types";
import {
  DatePickerField,
  PaymentOptionSelect,
  SelectInputField,
  TextInputField,
  SwitchField,
} from "../../../components/FormField";
import SoftBox from "../../../components/SoftBox";
import SoftButton from "../../../components/SoftButton";
import { filterPanelStyles } from "../../../examples/Tables/styles";
import { StatusEnum } from "../../../constants/status";

/** Compact filter tray keeps all existing fields and submission actions visible. */
const MerchantReportingFilters = (props) => {
  const { brands, onClearFilters, paymentOptions } = props;
  const now = new Date();

  const dateTimePickerOptions = {
    allowInput: false,
    enableTime: true,
    maxDate: now,
    time_24hr: true,
  };

  const statusOptions = [{ value: "", label: "All" }].concat(
    _.map(StatusEnum, (item) => ({ value: item, label: item }))
  );
  return (
    <SoftBox
      sx={(theme) => ({
        ...filterPanelStyles(theme),
        borderRadius: { xs: "22px 22px 0 0", sm: 0 },
      })}
    >
      <TextInputField label="Transaction ID" name="transactionId" />
      <SelectInputField
        name="brandId"
        label="Brand"
        message="Required"
        isClearable
        options={brands}
        placeholder="Select brand"
        classNamePrefix="table-filter"
      />
      <SelectInputField
        name="status"
        label="Status"
        options={statusOptions}
        placeholder="Select an status"
        classNamePrefix="table-filter"
      />
      <PaymentOptionSelect
        name="paymentOptionId"
        label="Payment Option"
        paymentOptions={paymentOptions}
        isClearable={true}
        classNamePrefix="table-filter"
      />
      <TextInputField label="Merchant Reference" name="merchantReference" />
      <TextInputField label="Email" name="email" />
      <DatePickerField name="fromDate" options={dateTimePickerOptions} label="From Date" />
      <DatePickerField name="toDate" options={dateTimePickerOptions} label="To Date" />
      <SoftBox
        sx={{
          gridColumn: "1 / -1",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1.5,
        }}
      >
        <SwitchField name="searchArchives" label="Search Archives" />
        <SoftBox display="flex" gap={1.25} ml="auto">
          <SoftButton variant="gradient" color="info" type="submit" size="small">
            Search
          </SoftButton>
          <SoftButton
            variant="outlined"
            color="info"
            type="button"
            size="small"
            onClick={onClearFilters}
          >
            Reset Filters
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default MerchantReportingFilters;

// Typechecking props of the MerchantReportingFilters
MerchantReportingFilters.propTypes = {
  brands: PropTypes.array,
  onClearFilters: PropTypes.func,
  paymentOptions: PropTypes.array,
};
